export default function AutoConfirmTimeline() {
  return (
    <div className="w-full bg-white rounded-lg px-2 py-6">
      <div className="relative h-24 max-w-full mx-auto">
        {/* 바(중앙) */}
        <div className="absolute left-4 right-4 top-1/2 -translate-y-1/2">
          {/* 회색 베이스 바 */}
          <div className="relative h-5 bg-gray-300 rounded-full border border-2">
            <div className="absolute left-[40%] top-0 h-full w-[40%] bg-white rounded-r-full"></div>
            {/* 픽업 가능(19:00~20:00) = 60%~100% */}
            <div className="absolute left-[60%] top-0 h-full w-[40%] bg-primary rounded-r-full"></div>
          </div>
        </div>

        {/* 세로 눈금 + 라벨 (17:30~20:00) */}
        {/* 공통: 컨테이너 좌우 패딩(4)만큼 보정 필요하므로 left-4/right-4 위에 배치 */}
        <div className="absolute inset-x-4 top-0 bottom-0">
          {/* === 눈금선들 === */}
          {/* 17:30 = 0% */}
          <div className="absolute left-[0%] top-3 bottom-3">
            <div className="w-px h-full bg-black/80"></div>
          </div>
          {/* 18:00 = 20% (점선) */}
          <div className="absolute left-[20%] top-3 bottom-3 -translate-x-1/2">
            <div className="w-0.5 h-full border-l-2 border-dashed border-gray-400 opacity-30"></div>
          </div>
          {/* 18:30 = 40% (자동확정, 빨강 실선) */}
          <div className="absolute left-[40%] top-3 bottom-3 -translate-x-1/2">
            <div className="w-px h-full bg-red-500"></div>
          </div>
          {/* 19:00 = 60% (픽업 시작, 빨강 실선) */}
          <div className="absolute left-[60%] top-3 bottom-3 -translate-x-1/2">
            <div className="w-px h-full bg-primary"></div>
          </div>
          {/* 19:30 = 80% (점선) */}
          <div className="absolute left-[80%] top-3 bottom-3 -translate-x-1/2">
            <div className="w-0.5 h-full border-l-2 border-dashed border-gray-400 opacity-30"></div>
          </div>
          {/* 20:00 = 100% (픽업 종료, 빨강 실선) */}
          <div className="absolute left-[100%] top-3 bottom-3 -translate-x-1/2">
            <div className="w-px h-full bg-primary"></div>
          </div>

          {/* === 상단 시간 라벨 === */}
          <div className="absolute inset-x-0 -top-2">
            <div className="absolute left-[0%] -translate-x-1/2 text-base sm:text-lg font-semibold text-black">
              17:30
            </div>
            <div className="absolute left-[20%] -translate-x-1/2 text-base sm:text-lg font-semibold text-black">
              18:00
            </div>
            <div className="absolute left-[40%] -translate-x-1/2 text-base sm:text-lg font-semibold text-black">
              18:30
            </div>
            <div className="absolute left-[60%] -translate-x-1/2 text-base sm:text-lg font-semibold text-black">
              19:00
            </div>
            <div className="absolute left-[80%] -translate-x-1/2 text-base sm:text-lg font-semibold text-black">
              19:30
            </div>
            <div className="absolute left-[100%] -translate-x-1/2 text-base sm:text-lg font-semibold text-black">
              20:00
            </div>
          </div>

          {/* === 하단 설명 라벨 === */}
          <div className="absolute inset-x-0 bottom-0 text-sm">
            <div className="absolute left-[0%] -translate-x-1/2 text-black">
              구매
            </div>
            <div className="absolute left-[20%] -translate-x-1/2 text-black">
              대기하기
            </div>
            <div className="absolute left-[40%] -translate-x-1/2 text-red-500 font-medium">
              자동확정
            </div>
            <div className="absolute left-[60%] -translate-x-1/2 text-primary font-medium">
              픽업 시작
            </div>
            {/* 19:30 하단 라벨은 없음(이미지 동일 구성) */}
            <div className="absolute left-[100%] -translate-x-1/2 text-primary font-medium whitespace-nowrap">
              픽업 종료
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
